import React from "react";

const Plans = () => {
  return (
    <>
      <div className="text-center text-xl bg-red-100 font-bold w-[100%] h-[100%]">
        Plans
      </div>
    </>
  );
};

export default Plans;
